import gql from 'graphql-tag';

export const GuestRateSession_Mutation = gql`
    mutation GuestRateSessionMutation(
        $input: GuestRateSessionInput!
    ) {
        guestRateSession(
            input: $input
        ) {
            teamId
        }
    }
`;
